export const REDUX_CONSTANTS = {
    FETCH_TODOS: "FETCH_TODOS",
    UPDATE_ALERT_MESSAGE: 'UPDATE_ALERT_MESSAGE',
    CLEAR_ALERT_MESSAGE: 'CLEAR_ALERT_MESSAGE',
    START_LOADER: 'START_LOADER',
    STOP_LOADER: 'STOP_LOADER',
    DYNAMIC_CONTENT_CON_HEIGHT: 'DYNAMIC_CONTENT_CON_HEIGHT',
    FETCH_STATUS_LIST: "FETCH_STATUS_LIST",
    FETCH_CATEGORY_LIST: "FETCH_CATEGORY_LIST",
    FETCH_SEVERITY_LIST: "FETCH_SEVERITY_LIST",
    FETCH_TRANSACTION_TYPE_LIST: "FETCH_TRANSACTION_TYPE_LIST",
    FETCH_SORT_OPTIONS: "FETCH_SORT_OPTIONS",
    UPDATE_FILTER_OBJ: "UPDATE_FILTER_OBJ",
    CLEAR_FILTERS: "CLEAR_FILTERS",
    UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",
    CREATE_CASHBOOK: "CREATE_CASHBOOK",
    GET_CASHBOOK_NAMES: 'GET_CASHBOOK_NAMES',
    CREATE_NEW_ENTRY: "CREATE_NEW_ENTRY",
    UPDATE_ENTRY: 'UPDATE_ENTRY',
    GET_ALL_ENTRIES: 'GET_ALL_ENTRIES',
    DELETE_ENTRY: "DELETE_ENTRY",
    DARK_MODE: "DARK_MODE",
    LIGHT_MODE: "LIGHT_MODE",
    CREATE_CHAT: "CREATE_CHAT",
    GET_CHATS: "GET_CHATS",
    CREATE_MESSAGE: "CREATE_MESSAGE",
    GET_MESSAGES: "GET_MESSAGES",
    
    FETCH_NOTES_LIST: "FETCH_NOTES_LIST",
    UPDATE_SELECTED_NOTES: "UPDATE_SELECTED_NOTES",

    UPDATE_CURRENT_LOCATION: "UPDATE_CURRENT_LOCATION",
    UPDATE_SELECTED_LOCATION: "UPDATE_SELECTED_LOCATION",
    UPDATE_CITIES_LIST: "UPDATE_CITIES_LIST",
    FILTER_CITIES_LIST: "FILTER_CITIES_LIST",
    UPDATE_TOAST: "UPDATE_TOAST",
    UPDATE_FORECAST_DATA: "UPDATE_FORECAST_DATA",

};